import { apiRequest, getSessionToken, getStoredUser, storeSession, clearSession } from './client';

export const loginRequest = async (username, password) => {
  try {
    const data = await apiRequest('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
    if (data.success) {
      storeSession(data.sessionToken, data.user);
      return { success: true, user: data.user };
    }
    return { success: false, error: data.error || 'Login failed' };
  } catch {
    return { success: false, error: 'Network error' };
  }
};

export const logoutRequest = async () => {
  try {
    if (getSessionToken()) await apiRequest('/api/auth/logout', { method: 'POST' });
  } catch {
    // best effort: always drop the local session
  } finally {
    clearSession();
  }
};

export const verifyRequest = async () => {
  try {
    const data = await apiRequest('/api/auth/verify');
    if (data.success) return { isValid: true, user: data.user };
    return { isValid: false };
  } catch {
    clearSession();
    return { isValid: false };
  }
};

export { getSessionToken, getStoredUser };
